import * as React from 'react';
import { Container } from 'types/Watchlist';
import EditIcon from '@mui/icons-material/Edit';
import { AssignmentModal } from 'pages/Shipments/components/customer-tag/assignment-modal';
import { CellProps } from './types';

export const ReferenceId: React.FC<CellProps> = (props) => {
  const container: Container = props.row;

  const [assignmentModalOpen, setAssignmentModalOpen] = React.useState(false);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAssignmentModalOpen((o) => !o);
  };

  return (
    <div className="p-2">
      <div
        onClick={handleClick}
        className="text-blue-900 flex items-center space-x-1 cursor-pointer max-w-full overflow-hidden"
      >
        <EditIcon style={{ fontSize: 14 }} />
        <h5 className="underline uppercase truncate">
          {container.customer ? container.customer.code : 'Add Reference'}
        </h5>
      </div>
      {assignmentModalOpen && (
        <AssignmentModal
          open={assignmentModalOpen}
          onClose={() => setAssignmentModalOpen(false)}
          selection={{ model: 'page', containers: [container], totalCount: 1 }}
          initialCustomer={container.customer || undefined}
          method="table-column"
        />
      )}
    </div>
  );
};
ReferenceId.displayName = 'ContainerTable.ReferenceId';
